import { Controller } from "@hotwired/stimulus"

// The daily submissions chart states its window totals at rest (rendered
// server-side into the readout target, so the line is never blank without
// JS), then swaps to that day's detail while a column is hovered or
// focused, and restores the totals on mouseleave/blur. Columns are
// tabindex="0" and respond to focus as well as mouseenter — this is not a
// mouse-only interaction.
export default class extends Controller {
  static targets = ["column", "readout"]
  static values = { total: Number, passed: Number, failed: Number }

  show(event) {
    const { date, passed, failed, rate } = event.currentTarget.dataset
    this.readoutTarget.textContent = `${date}: ${passed} passed, ${failed} did not (${rate}%)`
  }

  reset() {
    this.readoutTarget.textContent =
      `${this.totalValue} submissions · ${this.passedValue} passed · ${this.failedValue} did not`
  }
}
